module.exports = __webpack_public_path__ + "img/simulados-de-revisao.6b31ba94.png";